<template>

	<div class="col-md-6 col-sm-6">
		<div class="card  card-hover">
			<div class="card-header" style="z-index: 0">
				<h4 class="m-b-0 text-gray" style="margin-top:2%;z-index: 0">数据架构</h4>
			</div>
			<div class="card-body">
				<div class="d-flex flex-row comment-row m-t-0">
					<div class="p-2"><img src="/static/admin/assets/images/yymk/jg.png" alt="user" width="50"></div>
					<div class="comment-text w-100">
						<h6 class="font-medium">数据架构</h6>
						<span class="m-b-15 d-block">数据架构的数据集合 </span>
						<div class="comment-footer">
							<span class="label label-rounded label-info">菜单</span>
							<span class="action-icons">

								<a href="/admin/build/data/" class="btn btn-inverse">管理项目</a>

								<a href="/admin/build/data/0" class="btn btn-inverse">创建项目</a>

							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "table_bar",
		props: ["level1", "level2"]
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/sub/table_bar.vue